import Alpine from "alpinejs"

export default rhetoricalQuestion = ({ skipToStepPath }) => ({
  init() {
    this.store = Alpine.store("data")
    this.pageState = Alpine.store("pageState")

    this.store.internalTracker.isUserIdentified().then((isIdentified) => {
      if (!isIdentified) {
        this.store.internalTracker.trackIdentify({
          customData: { email: this.store.values.email },
          callBackFn: () => {
            this.store.internalTracker.trackPageView()
          },
        })
      }
    })
  },

  goToNextStep() {
    const nextStepPath = this.pageState.nextStepPath
    const isSkippable =
      !this.store.values.rhetoricalQuestionConfidentInClothes &&
      !this.store.values.rhetoricalQuestionMoreEnergy &&
      !this.store.values.rhetoricalQuestionDevelopHealthyHabits

    if (skipToStepPath && isSkippable) {
      window.location = skipToStepPath
      return
    }

    window.location.assign(nextStepPath)
  },

  storeData(field, value) {
    this.store.values[field] = value
  },

  handleReject(valueObject) {
    this.store.internalTracker.setEventToSessionStorage({ clickName: "Rhetorical Question Negative" })

    this.storeData(valueObject.field, valueObject.value)

    this.goToNextStep()
  },

  handleAccept(valueObject) {
    this.store.internalTracker.setEventToSessionStorage({ clickName: "Rhetorical Question Positive" })

    this.storeData(valueObject.field, valueObject.value)

    this.goToNextStep()
  },
})
